import { useFormikContext } from "formik";
import React from "react";
import { Template } from "../../../../../models";
import SwitchContainer from "../../common/SwitchContainer";

export default function IncludeSocialLinksToggle() {
  const { values, setFieldValue } = useFormikContext<Partial<Template>>();

  if (!values?.includeCredits) return null;

  return (
    <SwitchContainer
      title="Include Social Links"
      subTitle=""
      tooltip="Any social links added in your profile will appear as icon links at the bottom of the article below the article by."
      enabled={!!values?.includeSocialLinks}
      setEnabled={() =>
        setFieldValue("includeSocialLinks", !values?.includeSocialLinks)
      }
    />
  );
}
